import React, { useState } from 'react';
import { GiphyFetch } from '@giphy/js-fetch-api';
import { Grid } from '@giphy/react-components';

// Using a public API key for demo - in production, you'd want your own
const gf = new GiphyFetch('sXpGFDGZs0Dv1mmNFvYaGUvYwKX0PWIh');

interface GiphySearchProps {
  onSelectGif: (gifUrl: string) => void;
  onClose: () => void;
}

const GiphySearch: React.FC<GiphySearchProps> = ({ onSelectGif, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [searchKey, setSearchKey] = useState(0); // Force re-render when search changes

  const fetchGifs = (offset: number) => {
    if (searchTerm.trim()) {
      return gf.search(searchTerm, { offset, limit: 10, type: 'stickers' });
    } else {
      return gf.trending({ offset, limit: 10, type: 'stickers' });
    }
  };

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    setSearchKey(prev => prev + 1); // Force Grid to re-render with new search
  };

  return (
    <div className="giphy-search-overlay">
      <div className="giphy-search-modal">
        <div className="giphy-search-header">
          <h3>Add a Sticker</h3>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSearch} className="giphy-search-form">
          <input
            type="text"
            placeholder="Search Stickers..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="giphy-search-input"
          />
          <button type="submit" className="giphy-search-button">
            Search
          </button>
        </form>

        <div className="giphy-grid-container">
          <Grid
            key={searchKey}
            width={400}
            columns={2}
            fetchGifs={fetchGifs}
            onGifClick={(gif, e) => {
              e.preventDefault();
              // Get the original GIF URL
              const gifUrl = gif.images.original.url;
              onSelectGif(gifUrl);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default GiphySearch;